// scrollTop animation
// Ref from iview assist
export function scrollTop(el, to, from = 0, duration = 500) {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
    )
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil(difference / duration * 50)

  function scroll(start, end, step) {
    if (start === end) return

    let d = (start + step > end) ? end : start + step
    if (start > end) {
      d = (start - step < end) ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(to, from, step)
}
export function typeOf(obj) {
  const toString = Object.prototype.toString
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  }
  return map[toString.call(obj)]
}

// Get nested object value by String Key
export function ObjectByString(o, s) {
  s = s.replace(/\[(\w+)\]/g, '.$1') // convert indexes to properties
  s = s.replace(/^\./, '') // strip a leading dot
  var a = s.split('.')
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i]
    if (k in o) {
      o = o[k]
    } else {
      return
    }
  }
  return o
}

export function groupBy(list, keyGetter) {
  const map = new Map()
  list.forEach((item) => {
    const key = keyGetter(item)
    const collection = map.get(key)
    if (!collection) {
      map.set(key, [item])
    } else {
      collection.push(item)
    }
  })
  return map
}

export function isEmptyOrWhiteSpace(value) {
  return (value === null || value === '' || typeof value === 'undefined')
}

export function isEmpty(str) {
  return (!str || str.length === 0)
}

export function replaceWithDash(str) {
  return (isEmpty(str) ? '-' : str)
}

export function replaceWithBlank(str) {
  return (isEmpty(str) ? '' : str)
}

export function isZeroLength(str) {
  return (str.length === 0)
}

export function replaceWithBlk(str) {
  return (isZeroLength(str) ? '' : str)
}

export function replaceBWithBlank(str) {
  let val = ''
  if (str !== 'B') {
    val = str
  }
  return val
}

export function formatPrice(value) {
  // 2020-11-26 LYT SR5661
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
  let val = formatter.format(value)
  // let val = (value / 1).toFixed(2)
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// AR: 24-Aug-2020 Added for dynamic decimal places
export function formatPriceExt(value, places) {
  let val = (value / 1).toFixed(places)
  // val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return val
}
